export default "__VITE_ASSET__R_yKKniZ__"